export default "__VITE_ASSET__BvFcglBf__"